import React from 'react';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';
import { useForm } from 'react-hook-form';
import { NewAssigneeRow } from './NewAssigneeRow';
import { CurrentlyAssignedAlertMessage } from './CurrentlyAssignedAlertMessage';
import { ConfirmationRow } from './ConfirmationRow';
import { ButtonsRow } from './ButtonsRow';

interface PropTypes {
  isLoading: boolean;
  scheduledInterviewsCount: number;
  interviewTemplatesCount: number;
  handleClose: () => void;
}

interface FormValuesSelectOption {
  value: string;
  label: string;
}

export interface DeactivateUserFormValues {
  user: FormValuesSelectOption;
  confirmation: string;
}

export function ModalBody(props: PropTypes) {
  const { handleSubmit, control, register, formState, reset } =
    useForm<DeactivateUserFormValues>({
      mode: 'onChange',
      defaultValues: {
        user: null,
        confirmation: null,
      },
    });

  return props.isLoading ? (
    <LoadingSpinner />
  ) : (
    <>
      <CurrentlyAssignedAlertMessage
        scheduledInterviewsCount={props.scheduledInterviewsCount}
        interviewTemplatesCount={props.interviewTemplatesCount}
      />
      {/* This is dummy handleSubmit that will be replaced in the next PR of this Epic */}
      <form onSubmit={handleSubmit(() => console.log('test'))}>
        <NewAssigneeRow
          control={control}
          scheduledInterviewsCount={props.scheduledInterviewsCount}
          interviewTemplatesCount={props.interviewTemplatesCount}
        />
        <div className='fs-5 fw-regular mt-4 mb-3'>
          Do you wish to proceed with the deactivation of this user?
        </div>
        <ConfirmationRow register={register} errors={formState.errors} />
        <ButtonsRow
          onClose={props.handleClose}
          isValid={formState.isValid}
          reset={reset}
        />
      </form>
    </>
  );
}
